"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reset = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Reset = ({ fill = "#84E3FF", size = 16, title = "Reset", ...rest }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: true, fill: fill, ...rest },
    react_1.default.createElement("title", null, title),
    react_1.default.createElement("path", { d: "M14 9c0 3.3-2.7 6-6 6a6 6 0 0 1-5-9.3l1.6 1.2A4 4 0 0 0 8 13a4 4 0 0 0 2-7.5C9.4 5.2 8.7 5 8 5v2L6 5.5 4.3 4.2 4 4l4-3v2c.7 0 1.4.1 2 .3 2.3.9 4 3.1 4 5.7Z" })));
exports.Reset = Reset;
//# sourceMappingURL=Reset.js.map